export default "/images/f2f.png?cb6981027fa1f2f6e753b3838e240d16";